/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FlightSearchRequestor } from './FlightSearchRequestor';
import {
    FlightSearchRequestorFromJSON,
    FlightSearchRequestorFromJSONTyped,
    FlightSearchRequestorToJSON,
    FlightSearchRequestorToJSONTyped,
} from './FlightSearchRequestor';
import type { Location } from './Location';
import {
    LocationFromJSON,
    LocationFromJSONTyped,
    LocationToJSON,
    LocationToJSONTyped,
} from './Location';

/**
 * A search for flights
 * @export
 * @interface FlightSearchRequest
 */
export interface FlightSearchRequest {
    /**
     * 
     * @type {string}
     * @memberof FlightSearchRequest
     */
    id?: string;
    /**
     * 
     * @type {Location}
     * @memberof FlightSearchRequest
     */
    origin: Location;
    /**
     * 
     * @type {Date}
     * @memberof FlightSearchRequest
     */
    departureDate: Date;
    /**
     * 
     * @type {Location}
     * @memberof FlightSearchRequest
     */
    destination: Location;
    /**
     * 
     * @type {Date}
     * @memberof FlightSearchRequest
     */
    returnDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof FlightSearchRequest
     */
    cabinClass?: FlightSearchRequestCabinClassEnum;
    /**
     * Execute points search request if true
     * @type {boolean}
     * @memberof FlightSearchRequest
     */
    includePoints?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FlightSearchRequest
     */
    numPassengers: number;
    /**
     * Which backend serves the cash search. "duffel" returns bookable Duffel offers (default, unchanged behavior). "google_flights" returns scraped cash-priced offers plus a Google Flights link, and falls back to Duffel on scrape failure/block/empty parse. Round trips are served, but only by the provider's swoop path, which prices both legs in one call; the results-page scraper reads one-way rows only and reports the request as unservable so it too falls back.
     * @type {string}
     * @memberof FlightSearchRequest
     */
    provider?: FlightSearchRequestProviderEnum;
    /**
     * Internal narrowing control. When false and provider is "google_flights", return the typed Google Flights outcome without falling back to Duffel. Omission preserves the existing fallback behavior.
     * @type {boolean}
     * @memberof FlightSearchRequest
     */
    allowProviderFallback?: boolean;
    /**
     * Optional internal award-source allowlist for Google Flights enrichment. When present, fan out to exactly these canonical sources; an empty list disables award fan-out. Omission preserves airline-based source resolution.
     * @type {Set<string>}
     * @memberof FlightSearchRequest
     */
    pointsSources?: Set<FlightSearchRequestPointsSourcesEnum>;
    /**
     * Optional airline IATA codes or names. Used only when provider is "google_flights"; ignored by the Duffel provider.
     * @type {Array<string>}
     * @memberof FlightSearchRequest
     */
    airlines?: Array<string>;
    /**
     * Optional maximum number of stops per direction. Used only when provider is "google_flights"; ignored by the Duffel provider.
     * @type {number}
     * @memberof FlightSearchRequest
     */
    maxStops?: number;
    /**
     * 
     * @type {FlightSearchRequestor}
     * @memberof FlightSearchRequest
     */
    requestor?: FlightSearchRequestor;
}


/**
 * @export
 */
export const FlightSearchRequestCabinClassEnum = {
    First: 'first',
    Business: 'business',
    PremiumEconomy: 'premium economy',
    Economy: 'economy'
} as const;
export type FlightSearchRequestCabinClassEnum = typeof FlightSearchRequestCabinClassEnum[keyof typeof FlightSearchRequestCabinClassEnum];

/**
 * @export
 */
export const FlightSearchRequestProviderEnum = {
    Duffel: 'duffel',
    GoogleFlights: 'google_flights'
} as const;
export type FlightSearchRequestProviderEnum = typeof FlightSearchRequestProviderEnum[keyof typeof FlightSearchRequestProviderEnum];

/**
 * @export
 */
export const FlightSearchRequestPointsSourcesEnum = {
    American: 'american',
    Delta: 'delta',
    Alaska: 'alaska',
    Turkish: 'turkish',
    Etihad: 'etihad'
} as const;
export type FlightSearchRequestPointsSourcesEnum = typeof FlightSearchRequestPointsSourcesEnum[keyof typeof FlightSearchRequestPointsSourcesEnum];


/**
 * Check if a given object implements the FlightSearchRequest interface.
 */
export function instanceOfFlightSearchRequest(value: object): value is FlightSearchRequest {
    if (!('origin' in value) || value['origin'] === undefined) return false;
    if (!('departureDate' in value) || value['departureDate'] === undefined) return false;
    if (!('destination' in value) || value['destination'] === undefined) return false;
    if (!('numPassengers' in value) || value['numPassengers'] === undefined) return false;
    return true;
}

export function FlightSearchRequestFromJSON(json: any): FlightSearchRequest {
    return FlightSearchRequestFromJSONTyped(json, false);
}

export function FlightSearchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightSearchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'origin': LocationFromJSON(json['origin']),
        'departureDate': (new Date(json['departure_date'])),
        'destination': LocationFromJSON(json['destination']),
        'returnDate': json['return_date'] == null ? undefined : (new Date(json['return_date'])),
        'cabinClass': json['cabin_class'] == null ? undefined : json['cabin_class'],
        'includePoints': json['include_points'] == null ? undefined : json['include_points'],
        'numPassengers': json['numPassengers'],
        'provider': json['provider'] == null ? undefined : json['provider'],
        'allowProviderFallback': json['allow_provider_fallback'] == null ? undefined : json['allow_provider_fallback'],
        'pointsSources': json['points_sources'] == null ? undefined : new Set(json['points_sources']),
        'airlines': json['airlines'] == null ? undefined : json['airlines'],
        'maxStops': json['max_stops'] == null ? undefined : json['max_stops'],
        'requestor': json['requestor'] == null ? undefined : FlightSearchRequestorFromJSON(json['requestor']),
    };
}

export function FlightSearchRequestToJSON(json: any): FlightSearchRequest {
    return FlightSearchRequestToJSONTyped(json, false);
}

export function FlightSearchRequestToJSONTyped(value?: FlightSearchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'origin': LocationToJSON(value['origin']),
        'departure_date': value['departureDate'].toISOString().substring(0,10),
        'destination': LocationToJSON(value['destination']),
        'return_date': value['returnDate'] == null ? value['returnDate'] : value['returnDate'].toISOString().substring(0,10),
        'cabin_class': value['cabinClass'],
        'include_points': value['includePoints'],
        'numPassengers': value['numPassengers'],
        'provider': value['provider'],
        'allow_provider_fallback': value['allowProviderFallback'],
        'points_sources': value['pointsSources'] == null ? undefined : Array.from(value['pointsSources'] as Set<any>),
        'airlines': value['airlines'],
        'max_stops': value['maxStops'],
        'requestor': FlightSearchRequestorToJSON(value['requestor']),
    };
}

